export { useShallowSelector } from '../../hooks';

export const accountInfoBannerSelector = ({ entities }) => ({
  accountsById: entities.accounts.byId,
  advances: Object.values(entities.advances.byId),
  opportunities: Object.values(entities.opportunities.byId),
});
